import * as React from "react";
import { useParams } from "react-router-dom";
import {
  ExperienceProvider,
  ExperienceContext,
} from "@origin-digital/features";
import { useAppContext, IAppContext } from "../../AppContext";
import { withErrorBoundary } from "../ErrorBoundary";
import { IFetch, useDaxi } from "../../services/useDaxi";
import { getPrimaryMboxes, getOffers, capitaliseFirstName } from "./utils";
import { PrimaryPlacement } from "./PrimaryPlacement";

export interface ICustomerDetails {
  firstName: string;
}

const ControllerComponent = () => {
  const params = useParams();
  const context: IAppContext = useAppContext();
  const mboxes = getPrimaryMboxes(context.isNative);
  const customerDetails: IFetch<ICustomerDetails> = useDaxi<ICustomerDetails>(
    "/bin/origin-ui/getYourDetails",
    { xhr: true, shouldExecute: context.isAuthenticated }
  );

  if (Object.keys(params).length > 0) {
    // Only show if route params are empty (home page)
    return null;
  }

  const firstName = customerDetails?.data?.firstName;
  let heading = "Recommended for you";
  if (firstName && firstName.trim()) {
    heading += `, ${capitaliseFirstName(firstName)}`;
  }

  return (
    <ExperienceProvider mboxes={mboxes}>
      <ExperienceContext.Consumer>
        {({ targetOffers }) => {
          const contentForMboxes = getOffers(targetOffers, mboxes);
          return (
            <PrimaryPlacement offers={contentForMboxes} heading={heading} />
          );
        }}
      </ExperienceContext.Consumer>
    </ExperienceProvider>
  );
};

export const PrimaryPlacementController = withErrorBoundary(
  ControllerComponent
);
